import { useState } from 'react';

const aboutFaqs = [
  {
    q: 'Why choose Book My Studio Space?',
    a: 'Book My Studio Space provides flexible, high-quality professional studio environments designed for modern creators and businesses. Unlike traditional studio rentals, we offer transparent pricing, instant online booking, fully equipped spaces, and locations across six major US cities — without long-term commitments or membership fees.',
  },
  {
    q: 'Who is this service designed for?',
    a: 'Book My Studio Space is designed for photographers, videographers, podcasters, content creators, marketing agencies, and production companies of all sizes. Whether you shoot monthly or daily, our flexible booking options make professional studio access practical and affordable for any creative professional.',
  },
  {
    q: 'How does Book My Studio Space compare to other studio rental options?',
    a: 'We offer more transparent pricing, faster booking, and more consistent equipment quality than traditional studio rental options. Unlike single-studio operators, our multi-city network means the same booking experience and quality standards are available wherever your creative work takes you across the country.',
  },
  {
    q: 'How long has Book My Studio Space been operating?',
    a: 'Book My Studio Space was founded in 2019 and has grown from three New York City studio locations to over fifty studios across six major US markets. In that time we have supported over ten thousand creators, brands, and agencies with professional studio environments for photography, video, podcasting, and content creation.',
  },
  {
    q: 'How do I get started with Book My Studio Space?',
    a: 'Getting started is fast and simple. Browse our available studio spaces by type and city, choose your preferred date and time, complete secure online checkout, and receive immediate confirmation with all access details. Your first booking takes under five minutes with no approval process or membership required.',
  },
];

export default function AboutFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-white" id="faq">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3 block">Common Questions</span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900 mb-5">
            Frequently Asked Questions
          </h2>
          <p className="text-stone-500 text-lg">Everything you need to know about Book My Studio Space.</p>
        </div>

        <div className="space-y-3">
          {aboutFaqs.map((faq, idx) => (
            <div
              key={idx}
              className={`border rounded-xl overflow-hidden transition-all duration-200 ${openIndex === idx ? 'border-amber-400' : 'border-stone-200'}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer bg-white hover:bg-stone-50 transition-colors"
              >
                <span className="font-semibold text-stone-900 text-base leading-snug pr-4">{faq.q}</span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${openIndex === idx ? 'bg-amber-500 text-white rotate-45' : 'bg-stone-100 text-stone-500'}`}>
                  <i className="ri-add-line text-sm" />
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-6 pb-6 pt-1 border-l-4 border-amber-400 bg-amber-50/30">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-stone-50 rounded-2xl p-8 border border-stone-200">
          <h3 className="font-serif text-2xl font-bold text-stone-900 mb-3">Still have questions?</h3>
          <p className="text-stone-500 text-sm mb-6">Our team is happy to help you find the right studio for your project.</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href="tel:+18005551234" className="flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold px-6 py-3 rounded-lg transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line" /> Call (800) 555-1234
            </a>
            <a href="mailto:hello@bookmystudiospace.com" className="flex items-center gap-2 border border-stone-300 hover:border-stone-400 text-stone-700 text-sm font-semibold px-6 py-3 rounded-lg transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-mail-line" /> Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
